<template>
    <div>
        <h2>Chat Интеграция</h2>

        <div class="frow">
            <div class="form-controls">
                <a
                    href="#"
                    @click.prevent="onToggle"
                    :class="{ button: true, 'slack-button': true, 'disabled': loading || enabled }"
                >
                    Свържи <strong>Slack</strong> акаунта си
                </a>

                <a
                    v-if="enabled"
                    href="#"
                    @click.prevent="onTest"
                    :class="{ button: true, 'slack-button': true, 'disabled': loading }"
                >
                    Тествай <strong>Slack</strong> връзката
                </a>
            </div>

            <p class="chat-info" v-if="showChatLink">
                Потребител с вашия имейл не е намерен в Slack. Моля, настроите имейла в "Лична Информация" да съответства на този от Slack. След като го настроите, може да кликнете "Свържи" бутона отново.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            toggleUrl: window?.$$slack?.toggleUrl,
            testUrl: window?.$$slack?.testUrl,
            enabled: window?.$$slack?.enabled,
            loading: false,
            showChatLink: false,
        };
    },
    methods: {
        onToggle() {
            if (this.loading) {
                return;
            }

            const defaultError = 'There was an error while toggling Slack integration.';

            this.loading = true;
            fetch(this.toggleUrl, {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                body: JSON.stringify({}),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (!response?.success) {
                        if (response?.userNotFound) {
                            this.showChatLink = true;
                            return;
                        }
                        const message = response?.message ?? defaultError;
                        alert(message);
                        return;
                    }

                    this.showChatLink = false;
                    this.enabled = true;
                })
                .catch((error) => {
                    console.error(error);
                    alert(defaultError);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onTest() {
            if (this.loading) {
                return;
            }

            const defaultError = 'There was an error while sending the test message.';

            this.loading = true;
            fetch(this.testUrl, {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                body: JSON.stringify({}),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (!response?.success) {
                        const message = response?.message ?? defaultError;
                        alert(message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    alert(defaultError);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>

<style scoped>
.chat-info { margin-top: 2rem; font-size: 18px; }
</style>
